import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getCurrentSeason } from '../../../selectors/seasonSelectors';
import CropWaterEventCard from '../../../components/cards/CropWaterUse/CropWaterEventCard';
import CropWaterUseHeader from '../../../components/cards/CropWaterUse/CropWaterUseHeader';
import CropWaterUsePreview from '../../../components/cards/CropWaterUse/CropWaterUsePreview';
import { PanelCards } from '../../Panel';
import styles from './CropWaterPanel.css';
import { setActiveSubLayer } from '../../../actions/layersActions';

import { CROP_WATER_KEY } from '../../../constants/mapLayerIds';
import { HARVEST, PLANTING, WEATHER } from '../../../constants/cards';

const CARDS = [WEATHER, PLANTING, HARVEST];

export class CropWaterPanel extends Component {
  handleCardClick = (e) => {
    const {
      setActiveSubLayer: setActiveSubLayerProp,
      collapsePanel,
      index,
      activeSeason,
    } = this.props;
    setActiveSubLayerProp(
      CROP_WATER_KEY,
      e.currentTarget.id,
      index,
      activeSeason
    );

    collapsePanel();
  };

  // @todo: https://climate.jira.com/browse/CFVWEB-3776 refactor to avoid repetition
  onLeftClickPreview = () => {
    const {
      dates,
      currentDate,
      setActiveSubLayer: setActiveSubLayerProp,
      activeSeason,
      index: indexProp,
    } = this.props;
    const currentIndex = dates.indexOf(currentDate);
    const index = currentIndex < dates.length - 1 ? currentIndex + 1 : 0;

    setActiveSubLayerProp(
      CROP_WATER_KEY,
      dates[index],
      indexProp,
      activeSeason
    );
  };

  onRightClickPreview = () => {
    const {
      dates,
      activeSeason,
      currentDate,
      setActiveSubLayer: setActiveSubLayerProp,
      index: indexProp,
    } = this.props;
    const currentIndex = dates.indexOf(currentDate);
    const index = currentIndex > 0 ? currentIndex - 1 : dates.length - 1;

    setActiveSubLayerProp(
      CROP_WATER_KEY,
      dates[index],
      indexProp,
      activeSeason
    );
  };

  mapDates = (date, eventIndex) => {
    const { events, currentDate, locale } = this.props;
    const event = events[date];
    return (
      <CropWaterEventCard
        averageCropWaterUse={event.avgCropWaterUse}
        date={date}
        eventIndex={eventIndex}
        id={date}
        imageUrl={event.thumbnail}
        isActive={currentDate === date}
        key={date}
        locale={locale}
        onClick={this.handleCardClick}
      />
    );
  };

  getFirstCard = () => {
    const {
      dates,
      isSplitViewEnabled,
      isCollapsed,
      currentDate,
      events,
      locale,
    } = this.props;
    return (
      <div className={styles.panel}>
        {isSplitViewEnabled && isCollapsed && (
          <CropWaterUsePreview
            date={currentDate}
            locale={locale}
            onLeftClick={this.onLeftClickPreview}
            onRightClick={this.onRightClickPreview}
            precipitation={events[currentDate].avgCropWaterUse}
          />
        )}
        <CropWaterUseHeader isSplitViewEnabled={isSplitViewEnabled} />
        <div className={styles.events}>{dates.map(this.mapDates)}</div>
      </div>
    );
  };

  render() {
    const { isCollapsed, index } = this.props;
    return (
      <PanelCards
        cards={CARDS}
        firstCard={this.getFirstCard()}
        index={index}
        isCollapsed={isCollapsed}
        testId="cropwateruse"
      />
    );
  }
}

CropWaterPanel.propTypes = {
  activeSeason: PropTypes.string,
  collapsePanel: PropTypes.func.isRequired,
  currentDate: PropTypes.string,
  dates: PropTypes.array,
  events: PropTypes.object,
  index: PropTypes.number,
  isCollapsed: PropTypes.bool.isRequired,
  isSplitViewEnabled: PropTypes.bool,
  locale: PropTypes.string,
  setActiveSubLayer: PropTypes.func.isRequired,
};

function mapStateToProps(state, props) {
  const activeSeason = getCurrentSeason(state, props);
  const { byId, allIds, current } =
    state.layers.list[activeSeason][CROP_WATER_KEY];

  return {
    activeSeason,
    currentDate: current[props.index],
    dates: allIds,
    events: byId,
    locale: state.app.locale,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setActiveSubLayer }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CropWaterPanel);
